import axios from "axios";
import apicaller from "../../../utils/apicaller";
import api from "../../../main.api";

const resultList = raw => {
  if (Array.isArray(raw)) return raw;
  if (raw && Array.isArray(raw.data)) return raw.data;
  if (raw && Array.isArray(raw.people)) return raw.people;
  return [];
};
const resultTotal = (raw, list) => {
  if (Array.isArray(raw)) return raw.length;
  if (raw && raw.totalRowCount != null) return raw.totalRowCount;
  if (raw && raw.totalCount != null) return raw.totalCount;
  return list.length;
};
// Kisi uclari aktif analize baglanir; sunucu yalniz analiz yoksa yeni analiz acar.
const analysisQuery = () => {
  const analysisId = parseInt(sessionStorage.analysisId || 0);
  return analysisId > 0 ? `?analysisId=${analysisId}` : "";
};

const actions = {
  querySuspectsOverview({ commit }, payload) {
    const { cancelToken, ...filters } = payload || {};
    commit("setLoading", true);
    return apicaller
      .post(
        api.SUSPECTALBUM.queryOverview,
        filters,
        cancelToken ? { cancelToken } : undefined
      )
      .then(({ data }) => {
        // Middleware hatalari HTTP 200 + operationStatus:false govdesiyle doner -> bos basari sanilmaz.
        if (!data || data.operationStatus !== true) {
          throw new Error("querySuspectsOverviewFailed");
        }
        const raw = data && data.result;
        const list = resultList(raw);
        const totalCount =
          raw && raw.totalCount != null ? raw.totalCount : list.length;
        const truncated = !!(raw && raw.truncated);
        const stats =
          raw && raw.statsAvailable
            ? {
                photoCount: raw.photoCount || 0,
                kihbiCount: raw.kihbiCount || 0,
                jkipCount: raw.jkipCount || 0,
                uyapCount: raw.uyapCount || 0,
                wantedCount: raw.wantedCount || 0,
                cezaeviCount: raw.cezaeviCount || 0,
                crossCount: raw.crossCount || 0,
                crimeTotal: raw.crimeTotal || 0
              }
            : null;
        const clusters = raw && Array.isArray(raw.clusters) ? raw.clusters : [];
        const mode = (raw && raw.mode) || "";
        const locatedCount =
          raw && raw.locatedCount != null ? raw.locatedCount : list.length;
        commit("setPeople", list);
        commit("setClusters", clusters);
        return {
          data: list,
          totalCount,
          truncated,
          stats,
          clusters,
          mode,
          locatedCount
        };
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          console.error("querySuspectsOverview", err);
          commit("setPeople", []);
          commit("setClusters", []);
        }
        throw err;
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
  querySuspectsPage({ commit }, payload) {
    return apicaller
      .post(api.SUSPECTALBUM.query, payload)
      .then(({ data }) => {
        // Middleware hatalari HTTP 200 + operationStatus:false govdesiyle doner -> bos basari sanilmaz.
        if (!data || data.operationStatus !== true) {
          throw new Error("querySuspectsPageFailed");
        }
        const raw = data && data.result;
        const list = resultList(raw);
        const total = resultTotal(raw, list);
        commit("setPageItems", list);
        commit("setTotalRowCount", total);
        return { data: list, totalRowCount: total };
      })
      .catch(err => {
        console.error("querySuspectsPage", err);
        commit("setPageItems", []);
        commit("setTotalRowCount", 0);
        throw err;
      });
  },
  fetchLocationOptions(_ctx, payload) {
    return apicaller
      .post(api.SUSPECTALBUM.locations, payload)
      .then(({ data }) =>
        data && data.result ? data.result : { data: [], totalRowCount: 0 }
      )
      .catch(err => {
        console.error("fetchLocationOptions", err);
        throw err;
      });
  },
  getPhoto(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/photo`)
      .then(({ data }) => (data && data.result ? data.result : null))
      .catch(err => {
        console.error("getPhoto", err);
        return null;
      });
  },
  getPhotos(_ctx, ids) {
    return apicaller
      .post(api.SUSPECTALBUM.photos, { ids })
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getPhotos", err);
        return [];
      });
  },
  getPersonPhotos(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/photos`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getPersonPhotos", err);
        return [];
      });
  },
  getKihbiRecords(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/kihbi${analysisQuery()}`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getKihbiRecords", err);
        throw err;
      });
  },
  getUyapWarrant(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/uyap`)
      .then(({ data }) => (data && data.result ? data.result : null))
      .catch(err => {
        console.error("getUyapWarrant", err);
        throw err;
      });
  },
  getUyapHistory(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/uyap-history`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getUyapHistory", err);
        throw err;
      });
  },
  getResidents(_ctx, areaGeojson) {
    return apicaller
      .post(api.SUSPECTALBUM.residents, { areaGeojson })
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getResidents", err);
        throw err;
      });
  },
  getAreaMahalle(_ctx, areaGeojson) {
    return apicaller
      .post(api.SUSPECTALBUM.areaMahalle, { areaGeojson })
      .then(({ data }) => {
        // Middleware hatalari HTTP 200 + operationStatus:false govdesiyle doner -> asla bos-basariya cevirme.
        const r = data && data.result;
        if (!data || data.operationStatus !== true || !r || typeof r.count !== "number") {
          throw new Error("areaMahalleFailed");
        }
        return { count: r.count, names: r.names || [] };
      })
      .catch(err => {
        console.error("getAreaMahalle", err);
        throw err;
      });
  },
  getJkipRecords(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/jkip${analysisQuery()}`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getJkipRecords", err);
        throw err;
      });
  },
  getGenderOptions() {
    return apicaller
      .get(api.SUSPECTALBUM.genderOptions)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getGenderOptions", err);
        return [];
      });
  },
  getJkipSuckod(_ctx, { level, parent }) {
    const query = `?level=${level}&parent=${encodeURIComponent(parent || "")}`;
    return apicaller
      .get(`${api.SUSPECTALBUM.jkipSuckod}${query}`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getJkipSuckod", err);
        return [];
      });
  },
  getSameBuilding(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/same-building`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getSameBuilding", err);
        throw err;
      });
  },
  getSameStreetKihbi(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/same-street-kihbi`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getSameStreetKihbi", err);
        throw err;
      });
  },
  getContacts(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/contacts${analysisQuery()}`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getContacts", err);
        throw err;
      });
  },
  getRelations(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/relations${analysisQuery()}`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getRelations", err);
        throw err;
      });
  },
  getCezaeviRecords(_ctx, personId) {
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/cezaevi`)
      .then(({ data }) => (data && data.result ? data.result : []))
      .catch(err => {
        console.error("getCezaeviRecords", err);
        throw err;
      });
  },
  getCommonUyap(_ctx, { personId, currentPage, itemsPerPage }) {
    const query = `?currentPage=${currentPage || 1}&itemsPerPage=${itemsPerPage || 25}`;
    return apicaller
      .get(`${api.SUSPECTALBUM.base}/${personId}/common-uyap${query}`)
      .then(({ data }) =>
        data && data.result ? data.result : { edges: [], hasMore: false }
      )
      .catch(err => {
        console.error("getCommonUyap", err);
        throw err;
      });
  },
  getAreaBbox(_ctx, { type, ids }) {
    return apicaller
      .post(api.SUSPECTALBUM.areaBbox, { type, ids })
      .then(({ data }) => (data && data.result ? data.result : null))
      .catch(err => {
        console.error("getAreaBbox", err);
        return null;
      });
  },
  // Acilan kimlik degeri store'a YAZILMAZ: yalniz cagiran bilesenin yerel state'inde yasar,
  // sorgu/sayfa degisince maskeli hale geri doner (yuz tanima modulunun sozlesmesi).
  resolveIdentity(_ctx, payload) {
    return apicaller
      .post(api.SUSPECTALBUM.resolveIdentity, payload)
      .then(({ data }) =>
        data && data.result ? data.result : { success: false, identities: [] }
      )
      .catch(err => {
        console.error("resolveIdentity", err);
        throw err;
      });
  }
};

export default actions;
